<template>
  <g></g>
</template>

<script>
const START = 1960
const END = 2021

const INTERVAL = 200

const WAIT_UNTIL_RESTART = 3000

let value = START
let wait = 0
const callbacks = []

setInterval(() => {
  if (value < END) {
    value++
  } else {
    if (wait < WAIT_UNTIL_RESTART) {
      wait += INTERVAL
    } else {
      value = START
      wait = 0
    }
  }

  callbacks.forEach((fn) => fn(value))
}, INTERVAL)

export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  created () {
    callbacks.push((v) => this.$emit('input', v))
  }
}
</script>
